(() => {
'use strict';
if (customElements.get('tur-special-offers')) return;

class TurSpecialOffers extends HTMLElement {
 connectedCallback() {
  if (this.initialized) return;
  this.initialized = true;
  this.refreshCentral();
  this.addEventListener('click', event => { if(event.target.closest('[data-retry-offers]'))this.refreshCentral(); });
  this.addEventListener('click', event => {
   const button = event.target.closest('[data-offer-button]');
   if (button && !button.disabled && !this.busy) this.book(button);
  });
 }

 async refreshCentral(){
  if(!document.querySelector('tur-package-builder[data-central-checkout],tur-package-builder[data-payment-choice]'))return;
  const buttons=[...this.querySelectorAll('[data-offer-button]')];
  const status=this.querySelector('[data-status]');status.replaceChildren();
  buttons.forEach(b=>{b.disabled=true;b.setAttribute('aria-busy','true');});
  try{
   const response=await fetch('/apps/tur-seats/package/availability',{method:'POST',credentials:'same-origin',cache:'no-store',headers:{'Content-Type':'application/json'},body:'{}',signal:AbortSignal.timeout(20000)});
   if(!response.ok)throw Error('Goymslan kundi ikki heintast. Dagfør síðuna.');
   const data=await response.json(),counts=new Map(data.stays.map(s=>[s.id,s.quantity]));
   const needs={'54716830187793':['b2',1],'54716920103185':['b5',2],'54716921282833':['b0',1]};
   for(const b of buttons){const c=JSON.parse(b.closest('.turf-card').querySelector('[data-offer-config]').textContent),need=needs[c.variantId];const available=need&&(counts.get(need[0])||0)>=need[1];b.disabled=!available||!c.enabled;b.textContent=!c.enabled?'Bílegging letur upp skjótt':available?'Bílegg pakkan →':'Ikki tøkt í løtuni';}
  }catch(e){
   status.textContent='Sambandið við goymsluna slitnaði. Royn aftur fyri at kanna pakkarnar. ';
   const retry=document.createElement('button');retry.type='button';retry.dataset.retryOffers='';retry.textContent='Royn aftur';status.append(retry);
  }finally{buttons.forEach(b=>b.removeAttribute('aria-busy'));}
 }
 async book(button) {
  const status = this.querySelector('[data-status]');
  const say = message => { status.textContent = message; };
  const root = this.dataset.root.endsWith('/')
   ? this.dataset.root
   : this.dataset.root + '/';

  const format = cents => new Intl.NumberFormat('da-DK', {
   style: 'currency',
   currency: 'DKK'
  }).format(cents / 100);

  const get = async path => {
   const response = await fetch(root + path, {
    cache: 'no-store',
    credentials: 'same-origin'
   });
   if (!response.ok) {
    throw Error('Upplýsingarnar kundu ikki heintast. Royn aftur.');
   }
   return response.json();
  };

  let posted = false;
  let seatPlan = null;
  let seatService = null;
  this.busy = true;
  const buttons = [...this.querySelectorAll('[data-offer-button]')];
  const states = buttons.map(b => b.disabled);
  buttons.forEach(b => b.disabled = true);
  this.setAttribute('aria-busy', 'true');

  try {
   const c = JSON.parse(
    button.closest('.turf-card')
     .querySelector('[data-offer-config]').textContent
   );
   const n = c.adults + c.children;
   // Old sections continue to work with zero discount during installation.
   const discount = c.discount ?? 0;
   const total = c.price - discount;

   if (
    !c.enabled ||
    this.dataset.currency !== 'DKK' ||
    !Number.isInteger(n) ||
    n < 1
   ) {
    throw Error('Bílegging er ikki opin enn.');
   }
   if (
    !Number.isSafeInteger(c.price) ||
    !Number.isSafeInteger(discount) || discount < 0 ||
    !Number.isSafeInteger(total) || total < n * 50000 ||
    (c.finalPrice !== undefined && c.finalPrice !== total)
   ) {
    throw Error('Prísurin ella avslátturin skal kannast. Set teg í samband við FERÐAST.fo.');
   }

   say('Vit kanna pakkan og gera kurvina klára …');


   if(document.querySelector('tur-package-builder[data-central-checkout],tur-package-builder[data-payment-choice]')){
    if(!window.TurCentralPackageCheckout)throw Error('Bíleggingin kundi ikki lesast. Dagfør síðuna.');
    const cart=await get('cart.js');if(cart.currency!=='DKK'||cart.item_count)throw Error('Kanna kurvina, áðrenn tú byrjar eina pakkabílegging.');
    const seatConfig=JSON.parse(document.querySelector('tur-package-builder [data-package-seats]')?.textContent||'{}');
    let chosen=null;
    if(seatConfig.enabled){if(!window.TurPackageSeats)throw Error('Setursvalið er ikki klárt.');chosen=await window.TurPackageSeats.choose(seatConfig,{n,total,title:'Val av setri · '+c.title});if(!chosen)return;}
    await window.TurCentralPackageCheckout.stage({seatConfig,api:seatConfig.api||'/apps/tur-seats',selection:{offerId:c.variantId},expectedTotal:total,seatSelection:chosen});
    return;
   }
   const [product, deposit, cart] = await Promise.all([
    get('products/' + encodeURIComponent(c.handle) + '.js'),
    get('products/' + encodeURIComponent(c.depositHandle) + '.js'),
    get('cart.js')
   ]);

   if (cart.currency !== 'DKK') {
    throw Error('Vel DKK sum gjaldoyra fyri at bíleggja.');
   }
   if (cart.item_count) {
    throw Error('Tú hevur longu vørur í kurvini. Hygg at kurvini, áðrenn tú bíleggur henda pakkan.');
   }

   const variant = product.variants.find(v => String(v.id) === c.variantId);
   const dv = deposit.variants.find(v => String(v.id) === c.depositId);

   if (product.variants.length !== 1 || !variant?.available) {
    throw Error('Pakkin er ikki tøkur. Set teg í samband við FERÐAST.fo.');
   }
   // Compare the live product to the ORIGINAL price, not the discounted total.
   if (variant.price !== c.price) {
    throw Error('Prísurin er broyttur. Endurnýggja síðuna fyri at síggja nýggja prísin.');
   }
   if (
    deposit.variants.length !== 1 ||
    !dv?.available ||
    dv.price !== 50000 ||
    dv.requires_shipping ||
    total < n * 50000
   ) {
    throw Error('Depositum er ikki klárt. Set teg í samband við FERÐAST.fo.');
   }

   // Only the deposit is charged now. Totals below are order properties
   // for the existing manual balance collection, not a Shopify price override.
   const properties = {
    '_tur_language': 'fo',
    '_tur_booking': 'deposit-v1',
    '_tur_offer_variant': c.variantId,
    '_tur_original_price_cents': String(variant.price),
    '_tur_discount_cents': String(discount),
    '_tur_total_price_cents': String(total),
    'Ferð': 'Akureyri · ' + c.title,
    'Ferðatíð': '4.–7. mars 2027',
    'Vaksin': String(c.adults),
    'Børn': String(c.children),
    'Ferðafólk': String(n),
    'Ferðaslag': 'Sertilboð',
    ...(discount > 0 ? {
     'Prísur áðrenn avsláttur': format(variant.price),
     'Avsláttur fyri allan pakkan': format(discount)
    } : {}),
    'Samlaður ferðaprísur': format(total),
    'Depositum': format(n * 50000),
    'Eftir at gjalda': format(total - n * 50000),
    'Gisting': c.stay,
    'Leigubilar': String(c.cars),
    'Flogferð': 'Føroyar–Akureyri aftur og fram',
    'Skíleiga': n + ' ferðafólk',
    'Lyftukort': n + ' ferðafólk',
    'Íroknað í pakkanum': c.description
   };

   // Reuse the seat settings from the package builder on this page.
   const seatConfigNode = document.querySelector('tur-package-builder [data-package-seats]');
   const seatConfig = JSON.parse(seatConfigNode?.textContent || '{}');
   if (seatConfig.enabled) {
    seatService = window.TurPackageSeats;
    if (!seatService) throw Error('Tað bar ikki til at vísa valið av setri. Dagfør síðuna og royn aftur.');
    const selection = await seatService.choose(seatConfig, {n, total, title: 'Val av setri · ' + c.title});
    if (!selection) { say('Bíleggingin varð steðgað. Einki er lagt í kurvina.'); return; }
    // Recheck the published offer after time spent choosing seats.
    const sectionId = this.closest('[id^="shopify-section-"]')?.id.replace('shopify-section-', '');
    if (!sectionId) throw Error('Dagfør síðuna og vel pakkan av nýggjum.');
    const sectionUrl = new URL(location.href);sectionUrl.search = '';sectionUrl.hash = '';
    sectionUrl.searchParams.set('section_id', sectionId);
    const offerResponse = await fetch(sectionUrl, {cache: 'no-store', credentials: 'same-origin'});
    if (!offerResponse.ok) throw Error('Pakkin kundi ikki kannast. Royn aftur.');
    const offerDocument = new DOMParser().parseFromString(await offerResponse.text(), 'text/html');
    const freshOffers = [...offerDocument.querySelectorAll('[data-offer-config]')].map(x => JSON.parse(x.textContent));
    const freshOffer = freshOffers.find(x => x.variantId === c.variantId);
    if (!freshOffer || JSON.stringify(freshOffer) !== JSON.stringify(c)) throw Error('Pakkin ella prísurin er broyttur. Dagfør síðuna og vel av nýggjum.');
    seatPlan = await seatService.prepare(seatConfig, selection, c.depositId, properties);
   }

   // A network failure after this point has an uncertain outcome.
   // Never retry automatically.
   posted = true;
   const response = await fetch(root + 'cart/add.js', {
    method: 'POST',
    credentials: 'same-origin',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
     items: seatPlan ? seatPlan.items : [{id: c.depositId, quantity: n, properties}]
    })
   });
   if (!response.ok) {
    throw Error('Bíleggingin kundi ikki váttast. Kanna kurvina, áðrenn tú roynir aftur.');
   }

   const final = await get('cart.js');
   if (seatPlan) {
    seatService.complete(seatPlan, final);
   } else {
   const line = final.items.find(
    x => x.properties?._tur_offer_variant === c.variantId &&
         x.properties?._tur_booking === 'deposit-v1'
   );
   if (
    final.currency !== 'DKK' ||
    final.items.length !== 1 ||
    !line ||
    line.quantity !== n ||
    line.final_line_price !== n * 50000 ||
    final.total_price !== n * 50000 ||
    line.properties?._tur_total_price_cents !== String(total) ||
    line.properties?._tur_discount_cents !== String(discount) ||
    line.properties?.['Eftir at gjalda'] !== properties['Eftir at gjalda']
   ) {
    throw Error('Upphæddin í kurvini skal kannast. Opna kurvina ella set teg í samband við FERÐAST.fo.');
   }
   }
   window.location.assign('/fo/cart');

  } catch (error) {
   say(error.message || 'Eitthvørt gekk galið. Kanna kurvina.');
   const link = document.createElement('a');
   link.href = '/fo/cart';
   link.textContent = ' Sí kurvina →';
   status.append(link);
   if (posted || error.uncertain) {
    buttons.forEach(b => b.dataset.uncertain = 'true');
    say('Kanna kurvina, áðrenn tú roynir aftur. ' + (error.message || ''));
    status.append(link);
   }
  } finally {
   buttons.forEach((b, i) => {
    b.disabled = states[i] || b.dataset.uncertain === 'true';
   });
   this.busy = false;
   this.removeAttribute('aria-busy');
  }
 }
}
customElements.define('tur-special-offers', TurSpecialOffers);
})();

